export default __webpack_public_path__ + "static/media/5.cfccf5e3.jpg";